import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  /* width: ${props =>
    `calc(${props.width} - 2px)` ||
    '100%'}; TODO: Check if this can be safely changed to width: 100% */
  width: 100%;
  border: ${props => (props.error ? '3px solid red' : `thin solid ${props.theme.borderColor}`)};
  border-radius: ${props => (props.theme.borderRadius ? props.theme.borderRadius : 0)};
  background: ${props => props.theme.inputBackground || 'white'};
  background: ${({ disabled, theme }) => (disabled && `${theme.disabledInputBackground} !important`)};
  &:focus {
    border: ${({ theme }) => `thin solid ${theme.primaryColor}`};
    outline: none;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;
